/**
 * Telegram Mini App integratsiyasi.
 *
 * index.html'dagi rasmiy `telegram-web-app.js` skriptiga tayanadi — YANGI NPM PAKET
 * QO'SHILMAGAN (CLAUDE.md §3.4). Oddiy brauzer/PWA sifatida ochilganda `window.Telegram`
 * mavjud emas — bu holda hamma funksiya no-op, ilova avvalgidek PWA bo'lib ishlayveradi.
 *
 * Tema: bu modul temaga TEGMAYDI. `src/lib/theme` moduli Telegram colorScheme'ni
 * o'qiydi, `themeChanged` ga obuna bo'ladi va header/background ranglarini qo'yadi.
 */

import type { TelegramWebApp } from '@/types/telegram-web-app';

function getTelegramWebApp(): TelegramWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

/** Ilova Telegram ichida ochilganmi (oddiy brauzer/PWA'dan farqlash uchun). */
export function isTelegramWebApp(): boolean {
  return getTelegramWebApp() !== null;
}

/**
 * Orqaga tugmasini history API bilan boshqaradi — App.tsx va router/** muzlatilgan
 * (OWNERSHIP.md), shuning uchun react-router hook'lariga emas, brauzerning
 * pushState/popstate'iga ulanadi.
 */
export function wireBackButton(tg: TelegramWebApp): void {
  const isHomePath = (path: string): boolean => {
    const clean = path.replace(/\/+$/, '') || '/';
    return (
      clean === '/' ||
      clean === '/login' ||
      clean === '/register' ||
      clean === '/admin/dashboard' ||
      /^\/(client|manager|courier|agent|admin)$/.test(clean)
    );
  };

  const update = (): void => {
    if (isHomePath(window.location.pathname)) {
      tg.BackButton.hide();
    } else {
      tg.BackButton.show();
    }
  };

  tg.BackButton.onClick(() => {
    const idx = window.history.state?.idx;
    if (typeof idx === 'number' && idx > 0) {
      window.history.back();
    } else if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = '/';
    }
  });

  const originalPushState = window.history.pushState.bind(window.history);
  const originalReplaceState = window.history.replaceState.bind(window.history);

  window.history.pushState = function patchedPushState(...args: Parameters<History['pushState']>) {
    originalPushState(...args);
    update();
  };
  window.history.replaceState = function patchedReplaceState(...args: Parameters<History['replaceState']>) {
    originalReplaceState(...args);
    update();
  };
  window.addEventListener('popstate', update);

  update();
}

/**
 * `main.tsx`da ilova render qilinishidan oldin bir marta chaqiriladi.
 * Telegram ichida bo'lmasa (oddiy PWA) — hech narsa qilmaydi.
 */
export function initTelegramWebApp(): void {
  const tg = getTelegramWebApp();
  if (!tg) return;

  tg.ready();
  tg.expand();
  tg.disableVerticalSwipes?.();

  wireBackButton(tg);
  // Tema (colorScheme + header/background rangi) `src/lib/theme` moduli tomonidan
  // boshqariladi — u Telegram'ning `themeChanged` hodisasiga o'zi obuna bo'ladi va
  // foydalanuvchining qo'lda tanlagan temasini ustun qo'yadi.
}
